var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stays-section",class:[
    _vm.group.singleStayType && 'stays-section--solo-rate',
    _vm.group.isDealOfTheDay() && 'stays-section--deal-of-the-day'
  ]},[_c('div',{staticClass:"stays-section__meals"},[_c('MealPlansList',{attrs:{"meals":_vm.meals,"active":_vm.selectedStayId},on:{"selectedMeal":_vm.setActiveStay,"isRoomOnly":function($event){return _vm.$emit('isRoomOnly', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }